import SectionHeading from "@/components/base/SectionHeading";
import RatingStars from "@/components/base/RatingStars";
import { unboxings } from "@/mocks/unboxing";

const verdictStyle: Record<string, string> = {
  推荐回购: "bg-primary-100 text-primary-800",
  可以尝鲜: "bg-accent-100 text-accent-900",
  谨慎选择: "bg-secondary-100 text-secondary-900",
};

export default function UnboxSection() {
  return (
    <section id="unbox" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="美食开箱"
          title="拆开包装真吃一遍，用还原度告诉你值不值得买"
          description="开箱测评记录净含量、保存条件与加热后的真实表现，优缺点都写清楚，再给出明确的购买建议。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {unboxings.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.name} - 美食开箱配图`}
                  title={`${item.name} 开箱图片`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-semibold ${verdictStyle[item.verdict]}`}
                >
                  {item.verdict}
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-3 p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">{item.name}</h3>
                <div className="flex items-center justify-between">
                  <RatingStars value={item.score} />
                  <span className="text-sm font-semibold text-primary-700">{item.price}</span>
                </div>
                <div className="flex flex-col gap-1.5 text-xs text-foreground-600">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-scales-3-line text-secondary-600" aria-hidden="true" />
                    净含量：{item.netWeight}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fridge-line text-secondary-600" aria-hidden="true" />
                    保存：{item.shelfLife}
                  </span>
                </div>
                <ul className="flex flex-col gap-1.5 border-t border-background-200 pt-3 text-xs text-foreground-600">
                  {item.pros.map((pro) => (
                    <li key={pro} className="flex items-start gap-2">
                      <i className="ri-check-line mt-0.5 text-primary-600" aria-hidden="true" />
                      {pro}
                    </li>
                  ))}
                  <li className="flex items-start gap-2 text-foreground-500">
                    <i className="ri-subtract-line mt-0.5 text-foreground-400" aria-hidden="true" />
                    {item.cons}
                  </li>
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}